import { mapKeysToCamelCase } from '@skytech/utils'

import { get } from '@/util/auth'

import type { BuyoutOfferOriginal } from './types'

const IS_NEW_BACKEND_API = true
const API_ROUTE_BUYOUT_OFFERS = 'assets/buyout-offers'

export const getBuyoutOffersByAsset = async (assetId: number): Promise<BuyoutOfferOriginal[]> => {
  const offers = await get<BuyoutOfferOriginal[]>(
    `${API_ROUTE_BUYOUT_OFFERS}/asset/${assetId}`,
    IS_NEW_BACKEND_API
  )
  return mapKeysToCamelCase(offers).map(offer => ({
    ...offer,
    price: typeof offer.price === 'string' ? parseFloat(offer.price) : offer.price,
  }))
}

export const getActiveBuyoutOfferByAsset = async (
  assetId: number
): Promise<BuyoutOfferOriginal | null> => {
  try {
    const offer = await get<BuyoutOfferOriginal>(
      `${API_ROUTE_BUYOUT_OFFERS}/asset/${assetId}/active`,
      IS_NEW_BACKEND_API
    )
    const mappedOffer = mapKeysToCamelCase(offer)
    return {
      ...mappedOffer,
      price:
        typeof mappedOffer.price === 'string' ? parseFloat(mappedOffer.price) : mappedOffer.price,
    }
  } catch (error) {
    // Return null if no active offer exists
    return null
  }
}
